var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pt-5"},[_c('iframe',{staticClass:"w-100 py-0 my-0 chat-bot",attrs:{"src":"https://api.m60.com.br/v1/chatproxy?code=82nqUmdtnY2yEpUEdKpwN","frameborder":"0"}})])
}]

export { render, staticRenderFns }